import { ICON } from '@/constants/icons';
import { qx_ePrivilege_enum } from '@/graphql/types';
import { ConfigRouteObject } from '@/types';

export const INTRUSION_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fal', ICON.INTRUSION_PANEL],
  UI_LABEL: 'Intrusion',
  ROUTE_PATH: 'intrusion',
  ROUTE_NAME: 'intrusion.index',
  ROUTE_PARAM: '',
  // TODO(api): swap for a dedicated `IntrusionView` privilege once the backend defines one.
  // Reusing `DeviceView` for now keeps the link visible to the same users who see Devices/Sensors.
  PRIVILEGES: [qx_ePrivilege_enum.DeviceView]
};

export const INTRUSION_PARTITION_VIEW_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', ICON.LAYER_GROUP],
  UI_LABEL: 'View Partition',
  ROUTE_PATH: ':partitionId',
  ROUTE_NAME: 'intrusion.partition.view',
  ROUTE_PARAM: 'partitionId',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceView]
};

export const INTRUSION_PARTITION_VIEW_INFO_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', ICON.CIRCLE_INFO],
  UI_LABEL: 'Info',
  ROUTE_PATH: '',
  ROUTE_NAME: INTRUSION_PARTITION_VIEW_ROUTE.ROUTE_NAME,
  ROUTE_PARAM: 'partitionId',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceView]
};

export const INTRUSION_PARTITION_EDIT_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', ICON.EDIT],
  UI_LABEL: 'Edit',
  ROUTE_PATH: 'edit',
  ROUTE_NAME: 'intrusion.partition.edit',
  ROUTE_PARAM: 'partitionId',
  PRIVILEGES: [qx_ePrivilege_enum.IntrusionConfig]
};
